import React, { useState } from 'react';
import Typography from '@material-ui/core/Typography'

export function ShowMoreText(props) {
  const [open, setOpen] = useState(false)
  const { text, limit } = props;

  let limitText = text.slice(0, limit);
  for (let i = limitText.length - 1; i > 0; i--)
    if (limitText[i] === ' ') {
      limitText = limitText.slice(0, i)
      break;
    }

  return (
    <>
      <Typography
        {...props}
      >
        {text.length > limit
        ? <> {open ? text : limitText + '...'}
            <br /><span
              style={{color: '#3f51b5', cursor: 'pointer'}}
              onClick={() => setOpen(!open)}
            >
              {open ? " Скрыть" : " Показать еще"}
            </span>
          </>
        : text
        }
      </Typography>
    </>
  )
}
